import ColumnChart from "../Charts/ColumnChart";

const DashboardAmountByServiceChart = ({ dashBoardSummary, loading }) => {
    if (!dashBoardSummary?.ordersAmountByService) return null;

    return (
        <>
            <h3 className="text-center my-5">
                Monto de pedidos por servicio
            </h3>
            <div className="row mb-5">
                {
                    Object.keys(dashBoardSummary?.ordersAmountByService).length > 0 && !loading ?
                        <div className="col-md-12">
                            <ColumnChart
                                style={{ width: '50%' }}
                                label="value"
                                labelStartAdornment='$ '
                                categories={Object.keys(dashBoardSummary?.ordersAmountByService).map(key => dashBoardSummary?.ordersAmountByService[key]?.service.toLocaleUpperCase())}
                                defaultSeries={[
                                    {
                                        name: 'Mensual',
                                        data: Object.keys(dashBoardSummary?.ordersAmountByService).map(key => dashBoardSummary?.ordersAmountByService[key]?.Mensual || 0),
                                        color: '#34b4db'
                                    },
                                    {
                                        name: 'Extraordinario',
                                        data: Object.keys(dashBoardSummary?.ordersAmountByService).map(key => dashBoardSummary?.ordersAmountByService[key]?.Extraordinario || 0),
                                        color: '#df6adb'

                                    },
                                    {
                                        name: 'Manual',
                                        data: Object.keys(dashBoardSummary?.ordersAmountByService).map(key => dashBoardSummary?.ordersAmountByService[key]?.Manual || 0),
                                        color: '#5e74f4'
                                    },
                                ]}
                            />
                        </div>
                        :
                        <h3 className="text-center text-danger">
                            No hay datos para mostrar.
                        </h3>
                }

            </div>
        </>
    );
};

export default DashboardAmountByServiceChart;
